import type { Project } from "@/lib/tool-kit/qualitative-text/coding";

/** Highlight and swatch classes, one pair per code, handed out in creation order. */
const COLOURS = [
  { mark: "bg-amber-200/70 dark:bg-amber-400/30", swatch: "bg-amber-400" },
  { mark: "bg-sky-200/70 dark:bg-sky-400/30", swatch: "bg-sky-400" },
  { mark: "bg-rose-200/70 dark:bg-rose-400/30", swatch: "bg-rose-400" },
  {
    mark: "bg-emerald-200/70 dark:bg-emerald-400/30",
    swatch: "bg-emerald-400",
  },
  { mark: "bg-violet-200/70 dark:bg-violet-400/30", swatch: "bg-violet-400" },
  { mark: "bg-orange-200/70 dark:bg-orange-400/30", swatch: "bg-orange-400" },
  { mark: "bg-teal-200/70 dark:bg-teal-400/30", swatch: "bg-teal-400" },
  { mark: "bg-pink-200/70 dark:bg-pink-400/30", swatch: "bg-pink-400" },
] as const;

export function codeColourFor(project: Project, codeId: string) {
  const index = Math.max(
    0,
    project.codes.findIndex((code) => code.id === codeId)
  );
  return COLOURS[index % COLOURS.length] ?? COLOURS[0];
}
